module.exports = __webpack_public_path__ + "01_bob_yellow.ba1ad555.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_bob_yellow.png
// module id = MtvY
// module chunks = 0